import React from 'react';
import { PageComponentProps } from './types';

export const Unknown = (props: PageComponentProps) => {
  return <></>;
}
